<template>
  <Teleport to="#dialog-container">
    <transition name="fade">
      <div v-if="active" class="w-screen h-full absolute z-80000 left-0 bottom-0 flex flex-col items-end justify-end pointer-events-none">
        <div class="mx-auto m-6 w-full max-w-sm z-20 pointer-events-auto">
          <div
            class="px-3 py-4 bg-primary-600/95 rounded-xl shadow-lg mx-3 md:-mx-5 flex items-center justify-between"
            :class="[
              `bg-primary-${$auth.theme.light.shade}`,
              `dark:bg-gray-800 dark:border-r`,
            ]"
          >
            <div class="flex items-center mx-2">
              <o-icon :size="18" icon="warning" class="mr-3 text-white opacity-85" />
              <p class="text-white text-sm font-medium leading-none mt-px">
                Privacy Mode is enabled. Some information has been hidden.
              </p>
            </div>
            <div class="flex items-center space-x-1">
              <slot>
                <o-button variant="light" translucent class="mr-1" @click="$emit('disable')">
                  Disable
                </o-button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script setup lang="ts">
interface Props {
  active?: boolean
}

withDefaults(defineProps<Props>(), {
  active: false,
})

defineEmits<{
  (e: 'disable'): void
}>()
</script>
